import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const FeaturedIn: React.FC = () => {
  const publications = [
    {
      name: 'TechCrunch',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b9/TechCrunch_logo.svg',
    },
    {
      name: 'Forbes',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Forbes_logo.svg/2560px-Forbes_logo.svg.png',
    },
    {
      name: 'Wired',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Wired_logo.svg/2560px-Wired_logo.svg.png',
    },
    {
      name: 'VentureBeat',
      logo: 'https://venturebeat.com/wp-content/themes/vb-news/img/VB_Extended_Logo_600x60_Black.svg',
    },
    {
      name: 'The Next Web',
      logo: 'https://cdn0.tnwcdn.com/wp-content/themes/cyberdelia/assets/img/tnw.svg',
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#f5f5f5',
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          component="p"
          sx={{
            textAlign: 'center',
            color: '#666',
            mb: 4,
            fontSize: { xs: '0.875rem', md: '1rem' },
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            fontWeight: 600,
          }}
        >
          As Featured In
        </Typography>
        
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 4, md: 6 },
          }}
        >
          {publications.map((publication) => (
            <Box
              key={publication.name}
              sx={{
                height: { xs: '30px', md: '40px' },
                display: 'flex',
                alignItems: 'center',
                opacity: 0.4,
                transition: 'opacity 0.3s',
                '&:hover': {
                  opacity: 0.7,
                },
              }}
            >
              <img
                src={publication.logo}
                alt={publication.name}
                width="120"
                height="40"
                loading="lazy"
                decoding="async"
                style={{
                  height: '100%',
                  width: 'auto',
                  objectFit: 'contain',
                  filter: 'grayscale(100%)',
                }}
                onError={(e: any) => {
                  // Fallback to text if image fails to load
                  e.target.style.display = 'none';
                  const parent = e.target.parentElement;
                  if (parent) {
                    parent.innerHTML = `<span style="font-size: 1.5rem; font-weight: 700; color: #666; font-family: Arial, sans-serif;">${publication.name}</span>`;
                  }
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturedIn;